import { goFetch } from "@/utils/network-utils";
import type {
    EnrollmentDTO,
    EnrollmentInputDTO,
    EnrollmentResponseDTO,
    GetUserEnrollmentsRequestDTO,
    GetUserEnrollmentsResponseDTO
} from "@tmi/types/api/user-notifications";
import type { ApiFetchResponse } from "@tmi/types/api/fetch";

export async function addOrUpdateEnrollment( authToken: string | null, input: EnrollmentInputDTO ): Promise< ApiFetchResponse< EnrollmentResponseDTO > > {
    // we currently use the server response because the response tells us if there were contacts that need confirmation
    // and the server does not currently have confirmations enabled.
    return await goFetch< EnrollmentResponseDTO, EnrollmentInputDTO > ( {
        endpoint: `usernotification/enrollment`,
        payload: input,
        authToken: authToken,
        forceThrowExceptions: true
    } );
}

/**
 * The member's enrollments, or undefined when the request timed out, went offline or answered with something that is
 * not a list (goFetch resolves an empty body as `{}`). Callers keep what they had rather than store `undefined`
 * (forms-15). HTTP failures still reject.
 */
export async function getAllUserEnrollments( authToken: string | null ): Promise< Array< EnrollmentDTO > | undefined > {
    const request: GetUserEnrollmentsRequestDTO = {
        includeNotifications: true,
        includeScopes: false
    };

    const response =
        await goFetch< GetUserEnrollmentsResponseDTO, GetUserEnrollmentsRequestDTO >( {
            endpoint: `usernotification/getUserEnrollments`,
            authToken: authToken,
            payload: request
        } );

    const enrollments: unknown = response?.data;
    return Array.isArray( enrollments ) ? enrollments as Array< EnrollmentDTO > : undefined;
}
